import { render, staticRenderFns } from "./fiveEmotions.vue?vue&type=template&id=4dc8f61f&scoped=true"
import script from "./fiveEmotions.vue?vue&type=script&lang=js"
export * from "./fiveEmotions.vue?vue&type=script&lang=js"
import style0 from "./fiveEmotions.vue?vue&type=style&index=0&id=4dc8f61f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8f61f",
  null
  
)

export default component.exports